import { render, staticRenderFns } from "./AddOrUpFieldTmp.vue?vue&type=template&id=35c8575b&scoped=true&"
import script from "./AddOrUpFieldTmp.vue?vue&type=script&lang=js&"
export * from "./AddOrUpFieldTmp.vue?vue&type=script&lang=js&"
import style0 from "./AddOrUpFieldTmp.vue?vue&type=style&index=0&id=35c8575b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35c8575b",
  null
  
)

component.options.__file = "AddOrUpFieldTmp.vue"
export default component.exports